Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

/** Internal global with common properties and Sentry extensions  */

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ = globalThis ;

exports.GLOBAL_OBJ = GLOBAL_OBJ;
//# sourceMappingURL=worldwide.js.map
